import React from 'react';
import SessionActions from '../../SessionActions';

export default function SessionActionsWrapper({
    session,
    settings,
    me,
    eventUrls,
    showEmailLogin,
    toggleMarker,
    sessionViewType,
    toggleSessionRegistrationStatusPerSession,
    openCloseTicketSelectionPopUp,
    ticketsSelectionData,
    siteConf,
    event,
    setSessionFullRegistration,
    setLoginV2OffsetTop,
}) {
    const { color1 } = siteConf;

    return (
        <div className='session-actions font-size-14'>
            <SessionActions
                me={me}
                eventUrls={eventUrls}
                session={ session }
                toggleMarker={toggleMarker}
                showEmailLogin={showEmailLogin}
                sessionViewType={sessionViewType}
                sessionView
                color={color1}
                toggleSessionRegistrationStatusPerSession={toggleSessionRegistrationStatusPerSession}
                openCloseTicketSelectionPopUp={openCloseTicketSelectionPopUp}
                ticketsSelectionData={ticketsSelectionData}
                event={event}
                setSessionFullRegistration={setSessionFullRegistration}
                showAddToCal={settings?.showAddToCal}
                setLoginV2OffsetTop={setLoginV2OffsetTop}
                siteConf={siteConf}
            />
        </div>);
}
